import {
	Component, AfterContentChecked, AfterContentInit, Input, Output, OnInit, OnDestroy, EventEmitter, ContentChild, Optional, forwardRef, Host, Inject
} from '@angular/core';
import { FilterModel, IFilterModel, FilterItemModel, FilterItemRangeModel, IFilterQueryParams, FilterQueryParams } from '../models/filter.models';
import { SmFilterComponent } from './sm-filter.component';
import { SmFilterControlLabelDirective } from '../directives/sm-filter-control-label.directive';
import { Subscription } from 'rxjs';

@Component({
	selector: 'sm-filter-control',
	exportAs: 'smFilterControl',
	template: require('./sm-filter-control.component.html')
})
export class SmFilterControlComponent implements AfterContentInit {
	@Input() code: string;
	@Input() label: string = '';
	@Output() onChanged: EventEmitter<FilterItemModel> = new EventEmitter();

	@ContentChild(SmFilterControlLabelDirective) smFilterControlLabel: SmFilterControlLabelDirective;

	private _model: FilterItemModel;
	private _sub: Subscription;

	public get model() {
		if (!this._model) {
			this._model = {
				id: this.code,
				name: this.label || '',
				values: [],
				range: {
					start: null,
					end: null
				}
			};
		}

		return this._model;
	}

	public set model(val: FilterItemModel | null) {
		this._model = val;
	}

	ngAfterContentInit() {
		if (this.smFilterControlLabel) {
			this._model.name = this.smFilterControlLabel.label;
			this.label = this.smFilterControlLabel.label;
		}
	}

	fireOnChange() {
		if (this.onChanged) {
			this.onChanged.emit(this.model);
		}
	}
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/shared/components/sm-filter-control.component.ts